export enum DatasheetFieldComponentHeadingPosition {
  top = 1,
  left = 2,
  bottom = 3,
  right = 4,
}